import React from "react";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import { Grid, makeStyles, ChipGroup } from "../../../..";
import selects from "../../../../assets/selects";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    info: {
      display: "flex",
      "justify-content": "flex-start",
      padding: "15px",
      "align-items": "baseline"
    },
    client: {
      "min-width": "30%"
    },
    mr30: {
      "margin-right": "30px"
    },
    w60: {
      width: "60%"
    }
  };
});

var PaymentMethodsForm = function PaymentMethodsForm(_ref) {
  var mode = _ref.mode,
      translation = _ref.translation,
      values = _ref.values;
  var classes = useStyles();
  return [/*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.info
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "name",
    key: "name",
    name: "name",
    label: translation ? translation.inputs.name : "Name",
    component: TextField,
    fullWidth: true,
    className: classes.mr30,
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.info
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "type",
    key: "type",
    name: "type",
    label: translation ? translation.selects.type.placeholder : "Type",
    options: translation ? translation.selects.type.items : selects.payment_methods_types,
    className: classes.fullWidth,
    component: ChipGroup,
    margin: "normal",
    value: values.type,
    clickable: mode !== "view"
  }), values.type === "bank" && /*#__PURE__*/React.createElement(Field, {
    "data-cy": "account_number",
    name: "account_number",
    key: "account_number",
    label: translation ? translation.inputs.account_number : "Account Number (IBAN)",
    component: TextField,
    className: [classes.mr30, classes.w60].join(" "),
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.info
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "message",
    name: "message",
    key: "message",
    label: translation ? translation.inputs.message : "Message to be shown in the invoice when this method is selected",
    component: TextField,
    fullWidth: true,
    multiline: true,
    rows: 3,
    className: classes.mr30,
    variant: "outlined",
    disabled: mode === "view"
  }))];
};

export { PaymentMethodsForm };